import i18n, { getLocale } from ".";

const categoryTranslationKeys: Record<string, string> = {
  femea: "female", femeas: "females", bezerra: "femaleCalf", bezerras: "femaleCalves",
  novilha: "heifer", novilhas: "heifers", vaca: "cow", vacas: "cows",
  macho: "male", machos: "males", bezerro: "maleCalf", bezerros: "maleCalves",
  garrote: "youngBull", garrotes: "youngBulls", novilho: "steer", novilhos: "steers",
  boi: "ox", bois: "oxen", touro: "bull", touros: "bulls",
};

function normalizeCategoryName(name: string) {
  return name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
}

export function translateAnimalCategory(name?: string, ageDescription?: string) {
  if (!name) return "";
  let translationKey = categoryTranslationKeys[normalizeCategoryName(name)];
  if (ageDescription?.trim().match(/^de\s+9\s+a\s+12\s+meses$/i)) {
    const weanedKeys: Record<string, string> = {
      heifer: "femaleWeaned", heifers: "femaleWeanedPlural",
      youngBull: "maleWeaned", youngBulls: "maleWeanedPlural",
    };
    translationKey = weanedKeys[translationKey] || translationKey;
  }
  return translationKey ? i18n.t(`weightCategories.animalCategories.${translationKey}`) : name;
}

export function translateAnimalCategoryAge(description?: string, name?: string) {
  if (!description) return "";
  const categoryKey = name && categoryTranslationKeys[normalizeCategoryName(name)];
  if (getLocale() === "es" && (categoryKey === "bull" || categoryKey === "bulls")) return "";
  const range = description.trim().match(/^de\s+(\d+)\s+a\s+(\d+)\s+meses$/i);
  if (range) {
    return i18n.t("weightCategories.ageDescription.range", { min: range[1], max: range[2] });
  }
  const minimum = description.trim().match(/^a partir de\s+(\d+)\s+meses$/i);
  if (minimum) {
    return i18n.t("weightCategories.ageDescription.minimum", { min: minimum[1] });
  }
  return description;
}

export function translateAnimalCategoryDescription(category?: { name?: string; age_description?: string }) {
  if (!category) return "";
  return [translateAnimalCategory(category.name, category.age_description), translateAnimalCategoryAge(category.age_description, category.name)].filter(Boolean).join(" ");
}
